import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import { PlusIcon, MinusIcon} from 'common/components/icons';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import { TableBody, Table, TableRow, TableCell } from '@material-ui/core';
const styles = {
    root: {
        width: '100%',
    },
    lbIconWrapper: {
        borderStyle: 'solid',
        borderWidth: 'thin',
        borderColor: 'lightgray',
        padding: '5px',
        borderRadius: '10px',
        margin: '10px',
    },
    shadow: {
        webkitFilter: 'drop-shadow( 1px 2px 3px rgba(0, 0, 0, .7))',
        filter: 'drop-shadow( 1px 2px 3px rgba(0, 0, 0, .7))',
        /* Similar syntax to box-shadow */
    },
    cwafAccordion: {
        boxShadow: 'none',
        margin: 0
    },
    cwafAccordionSummaryContent: {
        margin: '0px',
        minHeight: '25px'
    },
    cwafAccordionExpanded: {
        height: 'auto',
        margin: 0,
        minHeight: 0
    },
    cwafAccordionDetails: {

    },

    cwafExpansionSummaryExpanded: {
        margin: '0 !important'
    },
    cwafExpansionSummary: {
        minHeight: '0 !important'
    },
    cwafExpansionIcon: {
        left: '-5px',
        top: '11px',
        right: 'auto'
    },
    gridSpacer: {
        paddingTop: '7px',
    },
    tableCell: {
        verticalAlign: 'center',
    },
    cwafTitle:{
        margin: '3px'
    },
    inlineBlock:{
        display: 'inline-block'
    },
    lineHeightNormal:{
        lineHeight: 'normal'
    },
    underMaintenanceText:{
        color: '#ffc107',
        lineHeight: 'normal'
    }
};
class CwafPanel extends React.Component {


    shouldComponentUpdate(nextProps, nextState){
        return this.props.expanded !== nextProps.expanded ||
               nextProps.shouldUpdate === 'all'
    }
    
    render() {
        const {
            classes,
            // isLoading,
            // regions,
            // reload,
            expanded,
            cwaf,
            togglePanel,
            // shouldUpdate,
            // setShouldUpdate,
        } = this.props
      
        return <Accordion expanded={expanded} onChange={togglePanel} classes={{ root: classes.cwafAccordion, expanded: classes.cwafAccordionExpanded }}>
            <AccordionSummary expandIcon={expanded ? <MinusIcon/> : <PlusIcon/> } className={classes.cwafAccordionSummaryContent} classes={{ root: classes.cwafExpansionSummary, content: classes.cwafAccordionSummaryContent, expandIcon: classes.cwafExpansionIcon, expanded: classes.cwafExpansionSummaryExpanded }}>
                <Grid className={classes.cwafTitle} container alignItems="center">
                    <Grid item xs={12}>
                        CWAF <Typography variant="caption" color="textSecondary" className={classes.inlineBlock}>{cwaf.hostname}</Typography>
                        <Typography variant="caption" color="textSecondary" className={classes.inlineBlock}>(AZ-{cwaf.az})</Typography>
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell className={classes.tableCell}>
                                    <Grid container alignItems="flex-start">
                                        <Grid item xs={12} className={classes.gridSpacer} />
                                        <Grid item xs={4} container alignItems="flex-start">
                                            <Typography variant="caption" color="textSecondary">Serial:</Typography>
                                            {cwaf.serial}
                                        </Grid>

                                        <Grid item xs={4} container alignItems="flex-start">
                                            <Typography variant="caption" color="textSecondary">Version: </Typography>
                                            {cwaf.version}
                                        </Grid>

                                        <Grid item xs={4} container alignItems="flex-start">
                                            <Typography variant="caption" color="textSecondary">VM State: </Typography>
                                            {cwaf.vm_state === 'NORMAL' ? <Typography className={classes.lineHeightNormal}
                                                variant='overline'
                                                color="secondary">
                                                {cwaf.vm_state}
                                            </Typography>
                                                :
                                                <Typography className={classes.lineHeightNormal}
                                                    variant='overline'
                                                    color="error">
                                                    {cwaf.vm_state}
                                                </Typography>
                                            }
                                        </Grid>
                                        <Grid item xs={12} className={classes.gridSpacer} />
                                    </Grid>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell className={classes.tableCell}>
                                    <Grid container alignItems="flex-start">
                                        <Grid item xs={12} className={classes.gridSpacer} />
                                        <Grid item xs={4} container alignItems="flex-start">
                                            <Typography variant="caption" color="textSecondary">LB Status: </Typography>
                                            {cwaf.lb_status === 'NORMAL' ? <Typography className={classes.lineHeightNormal}
                                                variant='overline'
                                                color="secondary">
                                                {cwaf.lb_status}
                                            </Typography>
                                                :
                                                <Typography className={classes.lineHeightNormal}
                                                    variant='overline'
                                                    color="error">
                                                    {cwaf.lb_status}
                                                </Typography>

                                            }
                                        </Grid>

                                        <Grid item xs={4}>
                                            <Typography variant="caption" color="textSecondary">Last Update: </Typography>
                                            <Typography variant="caption" className={classes.lineHeightNormal}>
                                            {
                                                moment.duration(Date.now() - Date.parse(cwaf.last_update)).days() + "d "
                                                + moment.duration(Date.now() - Date.parse(cwaf.last_update)).hours() + "h "
                                                + moment.duration(Date.now() - Date.parse(cwaf.last_update)).minutes() + "m "
                                            }
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={4}>
                                            <Typography variant="caption" color="textSecondary">Commit Hash: </Typography>
                                            {cwaf.commit_hash}
                                        </Grid>
                                        <Grid item xs={12} className={classes.gridSpacer} />
                                    </Grid>
                                </TableCell>
                            </TableRow>
                            <TableRow>

                                <TableCell className={classes.tableCell}>
                                    <Grid container>
                                        <Grid item xs={12} className={classes.gridSpacer} />
                                        <Grid item xs={4}>
                                            <Typography variant="caption" color="textSecondary">Under Maintenance: </Typography>
                                            {cwaf.under_maintenance === true ? <Typography className={classes.underMaintenanceText}
                                                variant='overline'
                                                >
                                                TRUE
                                            </Typography>
                                                :
                                                <Typography className={classes.lineHeightNormal}
                                                    variant='overline'
                                                    color="secondary">
                                                    FALSE
                                                </Typography>

                                            }
                                        </Grid>

                                        <Grid item xs={4}>
                                            <Typography variant="caption" color="textSecondary">WAF Image Version: </Typography>
                                            {cwaf.waf_image_version}
                                        </Grid>

                                        <Grid item xs={4}>
                                            <Typography variant="caption" color="textSecondary">Ignore During Healthcheck: </Typography>
                                            <Typography variant="overline" className={classes.lineHeightNormal}>
                                                {cwaf.ignore_during_healthcheck === true ? 'TRUE' : 'FALSE'}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} className={classes.gridSpacer} />
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                </Grid>
            </AccordionDetails>
        </Accordion>
    }
};

export default withStyles(styles)(CwafPanel);
